export default __webpack_public_path__ + "static/media/button.a82ffb7e.svg";